import { Box, styled, SxProps, useTheme } from "@mui/material";
import { StyleguideSavioColors, themeSettings } from "../../../configuration/themeSettings";
import TextConfirmButton from "../../AppButtons/TextConfirmButton";


export const TextConfirmButtonOrderOffer = styled(TextConfirmButton, {
    label: "basketdetailCollapsible_box",
})(({ theme }) => ({
    position: "absolute",
    bottom: "5px",
    right: "36px",
    width: "auto",
    minWidth: "163px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
    height: "35px",
    minHeight: "35px",
    fontSize: "1rem",
}));

export const BoxDataOrderOfferStyled = styled(Box, {
    label: "BoxDataOrderOffere_box",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "50%",
    '> div:first-of-type p': {
        paddingTop: 0,
    },
    '*':{
        fontSize: 14,
    }
}));

export const ColumnRight = styled("div", {
    label: "CreateOfferOrderForm_ColumnRight",
})(({ theme }) => ({
    display: "flex",
    flexDirection: 'column',
    flex: 1,
    paddingLeft: 30,
    'button': {
        alignSelf: 'flex-end',
    }


}));




export const BoxMainOrderOfferStyled = styled(Box, {
    label: "BoxMainOrderOffer_box",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
}));
;
export const useFormClasses = () => {
    const theme = useTheme();
    const classes = {
        title: {
            textTransform: "uppercase",
            color: StyleguideSavioColors.mainBlue,
            fontSize: "12px",
            fontWeight: "bold",

            paddingTop: "15px",
        } as SxProps,

        text: {
            textTransform: "uppercase",
            color: StyleguideSavioColors.text.black,
            fontSize: "12px",
            fontWeight: "normal",
        } as SxProps,

        options: {
            textTransform: "uppercase",
            color: StyleguideSavioColors.mainBlue,
            fontSize: "12px",
            fontWeight: "normal",
        } as SxProps,

        checkbox: {
            top: "5px",
            padding: "0px 0px 0px 10px"
        } as SxProps,
        input: {
            color: theme.palette.common.black,
            fontSize: "12px",
            fontFamily: themeSettings.main.typography.fontFamily,

            "&::placeholder": {
                opacity: "0.6",
            },
        } as SxProps,
    };
    return classes;
};
